import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommandExecutionHistoryItemsResult, GridRequestQuery } from '@api';
import { TableColumn } from '@swimlane/ngx-datatable';
import { map } from 'rxjs';
import { ComponentBaseDirective } from '../component.base';

@Component({
    selector: 'app-command-execution-list',
    templateUrl: './command-execution-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CommandExecutionListComponent extends ComponentBaseDirective {
    @Input() public commandExecutionHistorys: CommandExecutionHistoryItemsResult;
    @Input() public isAboveAssetLevel = true;

    @Output() public gridRequestEvent = new EventEmitter<GridRequestQuery>();

    @ViewChild('resultTemplate', { static: true }) private resultTemplate: TemplateRef<string>;
    @ViewChild('timestampTemplate', { static: true }) private timestampTemplate: TemplateRef<string>;
    @ViewChild('parameterValuesTemplate', { static: true }) private parameterValuesTemplate: TemplateRef<string>;
    @ViewChild('responseTemplate', { static: true }) private responseTemplate: TemplateRef<string>;

    public columns$ = this.translationService.afterLanguageChanged$.pipe(
        map(() => {
            const columns = [
                { name: this.translationService.translate('defaults.result'), prop: 'result', width: 80, maxWidth: 80, sortable: false, resizeable: false, cellTemplate: this.resultTemplate, canAutoResize: false },
                { name: this.translationService.translate('executionHistory.timestamp'), prop: 'timestamp', width: 180, maxWidth: 180, cellTemplate: this.timestampTemplate },
                { name: this.translationService.translate('defaults.command'), prop: 'command', width: 200, maxWidth: 200 },
                { $$id: 'parameterValues', name: this.translationService.translate('defaults.parameterValues'), prop: 'parameterValues', sortable: false, cellTemplate: this.parameterValuesTemplate },
                { name: this.translationService.translate('defaults.user'), prop: 'user', width: 170, maxWidth: 170 },
                { name: this.translationService.translate('defaults.response'), prop: 'response', width: 120, maxWidth: 120, sortable: false, resizeable: false, cellTemplate: this.responseTemplate, canAutoResize: false },
            ] as TableColumn[];

            if (this.isAboveAssetLevel) {
                columns.splice(2, 0, { name: this.translationService.translate('assets.name.singular'), prop: 'assetName' });
                columns[4] = { ...columns[4], width: 200, maxWidth: 200 };
            }

            return columns;
        })
    );

    public gridRequested(gridRequestQuery: GridRequestQuery) {
        this.gridRequestEvent.emit(gridRequestQuery);
    }
}
